import React, { ReactNode } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';
import logo from '../../img/logo-idnot.png';
import UserTile from '../external/UserTile';
import { HOME_PAGE_ROUTE, RATTACHEMENT_DEMANDE } from '../../routes';
import { logout } from '../../services/userService';
import CloseableComponent from '../external/CloseableComponent';
import {
  toastError,
  toastInfo,
  toastSuccess,
  toastWarning,
} from '../common/Notification';
import { Notifications } from '../../network/api/types/compte/Notification';
import noNotificationImage from '../../img/notification/notification_none.svg';
import notificationImage from '../../img/notification/notification_red.svg';
import notificationDepart from '../../img/notification/declarer_depart.svg';
import notificationWarning from '../../img/notification/en_cours.svg';
import notificationSucces from '../../img/notification/succes.svg';
import notificationDelegate from '../../img/notification/droits_delegues.svg';
import notificationRattachement from '../../img/notification/demande_rattachement.svg';
import { formatTimestamp } from '../../services/dateService';
import { fetchMyIdentity } from '../../services/user/userService';
import compteApi from '../../network/api/compteApi';
import { RattachementDemandEntite } from '../../network/api/types/RattachementDemand';
import RattachmentBouton from './component/RattachmentBouton';
import { getLinks } from '../../network/api/links';

type Props = RouteComponentProps & {
  fetchMyIdentity?: () => void,
  rattachementDemandEntiteList: RattachementDemandEntite,
  isUserManager?: boolean,
};

type State = {
  hamburgerOpen: boolean,
  notifications: Notifications[],
  notificationOpen: boolean,
};

const mapState = () => ({});

const mapDispatch = {
  fetchMyIdentity,
};

const connector = connect(mapState, mapDispatch);

class Header extends React.Component<Props, State> {
  state: State = {
    hamburgerOpen: false,
    notifications: [],
    notificationOpen: false,
  };

  componentDidMount() {
    this.props.fetchMyIdentity();

    compteApi.fetchNotification()
      .then((notifications) => {
        notifications.dtos.forEach((notification) => {
          if (!notification.read) {
            switch (notification.color) {
              case 'GREEN':
                toastSuccess(notification.text);
                break;
              case 'RED':
                toastError(notification.text);
                break;
              case 'REFUSED':
                toastError(notification.text);
                break;
              case 'ORANGE':
                toastWarning(notification.text);
                break;
              case 'BLUE':
                toastInfo(notification.text);
                break;
              default:
                toastInfo(notification.text);
            }
          }
        });
        this.setState({ notifications: notifications.dtos });
      });
  }

  hamburgerRef = React.createRef<HTMLButtonElement>();

  notificationRef = React.createRef<HTMLButtonElement>();

  toggleHamburger = () => {
    this.setState((prevState) => ({ hamburgerOpen: !prevState.hamburgerOpen }));
  };

  toggleNotification = () => {
    if (!this.state.notificationOpen) {
      // consume promise for ie11
      compteApi.readNotification().then(() => {});
      this.setState((prevState) =>
        ({ notificationOpen: !prevState.notificationOpen }));
    } else {
      const notificationRead = this.state.notifications
        .map((notification) => ({ ...notification, read: true }));
      this.setState((prevState) =>
        ({ notificationOpen: !prevState.notificationOpen, notifications: notificationRead }));
    }
  };

  logoutPage = (): void => {
    logout();
    window.location.href = getLinks().disconnectionLink;
  };

  getImage = (notificationColor: string): string => {
    switch (notificationColor) {
      case 'GREEN':
        return notificationSucces;
      case 'RED':
        return notificationRattachement;
      case 'REFUSED':
        return notificationRattachement;
      case 'ORANGE':
        return notificationWarning;
      case 'BLUE':
        return notificationDelegate;
      default:
        return notificationWarning;
    }
  };

  render(): ReactNode {
    return (
      <>
        <header className="mon-compte-header">
          <button type="button" onClick={() => this.props.history.push(HOME_PAGE_ROUTE)}>
            <img className="logo" src={logo} alt="logo" />
          </button>
          <div className="title-container">
            <h3>
              <Translate value="HEADER.MY_ID" />
            </h3>
            <div className="subtitle">
              <Translate value="HEADER.UNIQUE_ACCOUNT" />
            </div>
          </div>
          {this.props.isUserManager && (
            <RattachmentBouton
              nbPendingDemands={this.props
                .rattachementDemandEntiteList?.pendingRattachement?.length}
            />
          )}
          <div className="header-notifications">
            <button
              ref={this.notificationRef}
              type="button"
              onClick={this.toggleNotification}
              className="notification-button"
            >
              {
                this.state.notifications.filter((notification) => !notification.read).length > 0
                  ? <img src={notificationImage} alt="notification" />
                  : <img src={noNotificationImage} alt="notification" />
              }
            </button>
            <CloseableComponent
              isOpened={this.state.notificationOpen}
              toggle={this.toggleNotification}
              buttonRef={this.notificationRef.current}
              className="header-menu"
            >
              <div className="title">
                <Translate value="NOTIFICATION.TITLE" />
              </div>
              {this.props.isUserManager && (
                <div className="notification no-border">
                  <img alt="notification" src={notificationDepart} />
                  <Translate className="text" value="NOTIFICATION.DEPART" />
                  <div className="date" />
                </div>
              )}
              {
                this.state.notifications
                  .sort((a, b) => b.date.localeCompare(a.date))
                  .map((notification) => (
                    <div key={notification.id} className={`${notification.read ? '' : 'unread'}`}>
                      <div className="notification">
                        <img alt="notification" src={this.getImage(notification.color)} />
                        <span className="text">{notification.text}</span>
                        <div className="date">
                          <span>{formatTimestamp(notification.date)}</span>
                        </div>
                      </div>
                    </div>
                  ))
              }
              {!this.props.isUserManager && this.state.notifications.length === 0 && (
                <div className="notification no-border center">
                  <Translate value="NOTIFICATION.EMPTY" />
                </div>
              ) }
            </CloseableComponent>
          </div>
          <UserTile />
          <button
            className={`header-hamburger${this.state.hamburgerOpen ? ' open' : ''}`}
            type="button"
            ref={this.hamburgerRef}
            onClick={this.toggleHamburger}
          >
            <span />
            <span />
            <span />
            <span />
          </button>
          <CloseableComponent
            isOpened={this.state.hamburgerOpen}
            toggle={this.toggleHamburger}
            buttonRef={this.hamburgerRef.current}
            className="header-menu"
          >
            <div className="divider-horizontal" />
            <ul className="header-menu-list">
              <li>
                <button
                  className="header-list-item"
                  onClick={() => {
                    this.props.history.push(RATTACHEMENT_DEMANDE);
                    this.toggleHamburger();
                  }}
                  type="button"
                >
                  <Translate value="HEADER.RATTACHEMENT_DEMAND" />
                </button>
              </li>
              <li>
                <a
                  aria-label="Notacces"
                  href="https://intra.notaires.fr/jcms/lpo_3000242/fr/services/"
                  className="header-list-item"
                >
                  <Translate value="HEADER.NOTACCESS" />
                </a>
              </li>
              <li>
                <button
                  className="header-list-item"
                  onClick={this.logoutPage}
                  type="button"
                >
                  <Translate value="HEADER.DISCONNECT" />
                </button>
              </li>
            </ul>
          </CloseableComponent>
        </header>
      </>
    );
  }
}

export default connector(withRouter(Header));
